// src/components/private/common_components/DateFilters.js
// This is the DateFilters component

import React from 'react';
import { Button, Form, Row, Col, OverlayTrigger, Tooltip, InputGroup } from 'react-bootstrap';

const DateInput = ({ value, onChange, placeholder, onClear }) => {
    return (
        <InputGroup>
            <Form.Control
                type="date"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
            />
            {value && (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Clear Date</Tooltip>}
                >
                    <Button variant="outline-secondary" onClick={onClear}>
                        <i className="bi bi-x-circle"></i>
                    </Button>
                </OverlayTrigger>
            )}
        </InputGroup>
    );
};


const DateFilters = ({ startDate, setStartDate, endDate, setEndDate, applyFilters, clearFilters }) => {
    return (
        <Form>
            <Row className="align-items-end">
                <Col md="6">
                    <Form.Group controlId="startDate">
                        <DateInput
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            placeholder="Start Date"
                            onClear={() => {
                                setStartDate(''); // Clear start date
                            }}
                        />
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group controlId="endDate">
                        <DateInput
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            placeholder="End Date"
                            onClear={() => {
                                setEndDate(''); // Clear end date
                            }}
                        />
                    </Form.Group>
                </Col>
                {/* Button for 'Apply Filters' commented out */}
                {/* 
                <Col xs="auto" md="2">
                    <Button
                        variant="primary"
                        className="custom-button-portal"
                        onClick={applyFilters}>
                        Apply Filters
                    </Button>
                </Col>
                */}
                {/* Button for 'Clear Filters' commented out */}
                {/* 
                <Col md="2" className="d-flex align-items-end">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-clear-filters">Clear Filters</Tooltip>}
                    >
                        <Button className="bi bi-x-circle" style={{ cursor: 'pointer' }} onClick={clearFilters}></Button>
                    </OverlayTrigger>
                </Col>
                */}
            </Row>
        </Form>
    );
};

export default DateFilters;
